import T from "../components/translations/Translations";

export const getEducationalTrackWords = (str) => {
    if (!str || str === "NOT_APPLICABLE") {
        return;
    }

    const tmpArr = str.split("_");
    const tmp = `(${tmpArr[0].charAt(0).toUpperCase()}${tmpArr[0].slice(1).toLowerCase()} ${tmpArr[1].charAt(0).toUpperCase()}${tmpArr[1].slice(1).toLowerCase()})`;

    return tmp;
};

export const getKinderWords = (arrOrString) => {
    if (!arrOrString) {
        return;
    }
    const arrayFromStr = arrOrString.split(",");
    if (Array.isArray(arrayFromStr) && arrayFromStr?.length > 1) {
        let strArr = arrayFromStr.map((item) => {
            if (item === "K_HALF_AM") {
                return T({ key: "OEApp_HalfDayAM" });
            }
            if (item === "K_HALF_PM") {
                return T({ key: "OEApp_HalfDayPM" });
            }
            if (item === "K_FULL") {
                return T({ key: "OEApp_FullDay" });
            }

            return item;
        });

        return strArr.join(", ");
    }

    if (arrOrString === "K_HALF_AM") {
        return T({ key: "OEApp_HalfDayAM" });
    }
    if (arrOrString === "K_HALF_PM") {
        return T({ key: "OEApp_HalfDayPM" });
    }
    if (arrOrString === "K_FULL") {
        return T({ key: "OEApp_FullDay" });
    }

    return arrOrString;
};

export const getLanguageWords = (arrOrString) => {
    if (!arrOrString) {
        return;
    }
    const arrayFromStr = arrOrString.split(",");
    if (Array.isArray(arrayFromStr) && arrayFromStr?.length > 1) {
        let strArr = arrayFromStr.map((item) => {
            if (item === "ENGLISH") {
                return T({ key: "OEApp_English" });
            }
            if (item === "FRENCH") {
                return T({ key: "OEApp_French" });
            }
            if (item === "MANDARIN") {
                return T({ key: "OEApp_Mandarin" });
            }
            if (item === "SPANISH") {
                return T({ key: "OEApp_Spanish" });
            }

            return item;
        });

        return strArr.join(", ");
    }

    return `${arrOrString.charAt(0).toUpperCase()}${arrOrString.substr(1).toLowerCase()}`;
};

export const getStatusWords = (status) => {
    let stat = status;
    switch (status) {
        case "ACCEPT_OFFER":
            // stat = "Accepted Offer";
            stat = T({ key: "OEApp_ACCEPT_OFFER" });
            break;
        case "CANCELLED_REQUEST":
            // stat = "Cancelled Request";
            stat = T({ key: "OEApp_CANCELLED_REQUEST" });
            break;
        case "CHANGED_ENROLLMENT":
            // stat = "Unenrolled";
            stat = T({ key: "OEApp_CHANGED_ENROLLMENT" });
            break;
        case "CHOICE_CREATED":
            // stat = "School Choice Created";
            stat = T({ key: "OEApp_CHOICE_CREATED" });
            break;
        case "CHOICE_INCOMPLETE":
            // stat = "Choice Incomplete";
            stat = T({ key: "OEApp_CHOICE_INCOMPLETE" });
            break;
        case "DENY_OFFER":
            // stat = "Denied Offer";
            stat = T({ key: "OEApp_DENY_OFFER" });
            break;
        case "DENY_REQUEST":
            // stat = "Denied Request";
            stat = T({ key: "OEApp_DENY_REQUEST" });
            break;
        case "ENROLLED":
            // stat = "Enrolled";
            stat = T({ key: "OEApp_ENROLLED" });
            break;
        case "INVALID":
            // stat = "Invalid";
            stat = T({ key: "OEApp_INVALID" });
            break;
        case "MAKE_OFFER":
            // stat = "Offer Made";
            stat = T({ key: "OEApp_MAKE_OFFER" });
            break;
        case "MAKE_OFFER_PENDING":
            // stat = "Make Offer Pending";
            stat = T({ key: "OEApp_MAKE_OFFER_PENDING" });
            break;
        case "NO_RESPONSE":
            // stat = "No Response";
            stat = T({ key: "OEApp_NO_RESPONSE" });
            break;
        case "WAIT_LIST":
            // stat = "On Wait List";
            stat = T({ key: "OEApp_WAIT_LIST" });
            break;
        case "REQUEST":
            // stat = "Request Made";
            stat = T({ key: "OEApp_REQUEST" });
            break;
        case "UNENROLLED":
            // stat = "Unenrolled";
            stat = T({ key: "OEApp_UNENROLLED" });
            break;
        default:
            // stat = "Unavailable";
            stat = T({ key: "OEApp_UNAVAILABLE" });
            break;
    }

    return stat;
};
